import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { getMyStores } from "../api/stores";

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
    const [stores, setStores] = useState([]);
    const [isStoreLoading, setIsStoreLoading] = useState(false);
    const { isLoggedIn } = useAuth();

    useEffect(() => {
        if (!isLoggedIn) {
            setStores([]);
            return;
        }

        const fetchStores = async () => {
            setIsStoreLoading(true);
            try {
                const response = await getMyStores();
                if (response.success) {
                    setStores(response.data.stores);
                }
            } catch (error) {
                console.error("상점 정보를 가져오는데 실패했습니다:", error);
            } finally {
                setIsStoreLoading(false);
            }
        };

        fetchStores();
    }, [isLoggedIn]);

    return (
        <StoreContext.Provider value={{ stores, isStoreLoading }}>
            {children}
        </StoreContext.Provider>
    );
};

export const useStore = () => useContext(StoreContext);
